<template>
  <v-main class="parallax__container">
    <v-container>
      <DiptychCard
        background-left="#1098f7"
        width="900px"
        height="470px"
        :border-radius="30"
      >
        <template slot="diptych-left">
          <v-img
            max-width="350"
            src="../../assets/img/ranking_monochromatic.svg"
          ></v-img>
        </template>
        <template slot="diptych-right">
          <div class="px-15">
            <h1 class="mb-8 text-center">Sistema de Atencion de Colas</h1>
            <LoginForm :loading="loading" @submit="login" />
          </div>
        </template>
      </DiptychCard>
    </v-container>
  </v-main>
</template>

<script>
import DiptychCard from '@/infrastructure/vue/components/common/cards/DiptychCard';
import LoginForm from '@/infrastructure/vue/components/common/forms/LoginForm';

export default {
  name: 'LoginPage',
  components: {
    DiptychCard,
    LoginForm,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    async login(payload) {
      this.loading = true;
      await this.$store.dispatch('login/loginAction', payload);
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="scss">
.parallax__container {
  background-image: url('https://cdn.vuetifyjs.com/images/parallax/material2.jpg');
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-color: #e84a1a;
}
</style>
